import './ProgressCircle.css';

const ProgressCircle = ({ percent, text, radius = 15 }: { percent: number, text?: string, radius?: number }) => {
    const strokeWidth = radius / 4;
    const circumference = 2 * Math.PI * radius;
    const over100 = percent > 100;
    percent = over100 ? percent - 100 : percent
    const offset = circumference - (percent / 100) * circumference;

    return (
        <div className="progress-container my-auto">
            <svg
                className="progress-ring"
                width={2 * radius}
                height={2 * radius}
                viewBox={`0 0 ${2 * radius} ${2 * radius}`}
            >
                <circle
                    className={over100 ? "progress-ring-progress" : "progress-ring-background"}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    cx={radius}
                    cy={radius}
                    r={radius}
                />
                <circle
                    className={over100 ? "progress-ring-over100" : "progress-ring-progress"}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    cx={radius}
                    cy={radius}
                    r={radius}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                />
            </svg>
            <div className="progress-value">{text}</div>
        </div>
    );
};

export default ProgressCircle;
